import { useStore } from 'ra-core';
export var useTheme = function (themeOverride) { return useStore('theme', themeOverride); };
